import { MapContainer } from "react-leaflet"
import { Position } from "./types"
import { swapLatLng } from "./utils"

type Props = {
  bounds: Position[]
  children: React.ReactNode
  height?: string
}

export const Map = ({ bounds, children, height = `60vh` }: Props) => (
  <MapContainer
    bounds={bounds.map((x) => swapLatLng(x))}
    boundsOptions={{ padding: [40, 40] }}
    doubleClickZoom={false}
    scrollWheelZoom
    style={{ height }}
  >
    {children}
  </MapContainer>
)

Map.defaultProps = {
  height: undefined,
}
